<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :modal="true"
    :show-close="false"
    width="70%"
    custom-class="image-modal"
    @close="$emit('close')"
  >
    <span slot="title" class="image-modal__header">
      <i
        :class="['image-modal__download', downloadLoading ? 'el-icon-loading' : 'el-icon-download']"
        :style="{ cursor: downloadLoading ? 'not-allowed' : 'pointer' }"
        @click="downloadImage"
        title="下载图片"
      />
      <i class="el-icon-close image-modal__close" @click="dialogVisible = false" title="关闭" />
    </span>
    <hr class="image-modal__divider" />
    <div class="image-modal__content">
      <el-image
        :src="imageSrc"
        :alt="imageAlt"
        :preview-src-list="imageSrc ? [imageSrc] : []"
        fit="contain"
        class="image-modal__img"
      />
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'ImageModal',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    imageSrc: {
      type: String,
      default: ''
    },
    imageAlt: {
      type: String,
      default: ''
    },
    downloadFilename: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dialogVisible: false,
      downloadLoading: false
    };
  },
  watch: {
    isOpen(val) {
      this.dialogVisible = val;
    },
    dialogVisible(val) {
      if (!val && this.isOpen) {
        this.$emit('close');
      }
    }
  },
  created() {
    this.dialogVisible = this.isOpen;
  },
  methods: {
    downloadImage() {
      if (!this.imageSrc || this.downloadLoading) return;
      this.downloadLoading = true;
      let filename = this.downloadFilename;
      if (!filename) {
        const match = this.imageSrc.match(/\/([^/?#]+\.(png|jpg|jpeg|gif|webp))(?:\?|$)/i);
        filename = match ? match[1] : (this.imageAlt || 'image').replace(/\s+/g, '-') + '.png';
      }
      const link = document.createElement('a');
      link.href = this.imageSrc;
      link.download = filename;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setTimeout(() => {
        this.downloadLoading = false;
      }, 800);
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .image-modal .el-dialog__body {
  padding:0rem 1rem 1rem 1rem;
  
}
::v-deep .image-modal {
  border-radius: .75rem;
}
.image-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.image-modal__download,
.image-modal__close {
  font-size: 24px;
  cursor: pointer;
  transition: color 0.2s;
}

.image-modal__download {
  color: #0f52ba;

  &:hover {
    color: #1a5fc4;
  }
}

.image-modal__close {
  color: #909399;

  &:hover {
    color: #606266;
  }
}

.image-modal__divider {
  margin: 0 0 1rem 0;
  border: none;
  border-top: 2px solid #e4e7ed;
}

.image-modal__content {
  text-align: center;
  // padding: 20px;
}

.image-modal__img {
  max-width: 100%;
  display: block;
  margin: 0 auto;
}
.image-modal__img ::v-deep .el-image__inner {
  max-width: 100%;
  height: auto;
}
</style>

